import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext(null);

export function ThemeProvider({ children }) {
  const [dark, setDark] = useState(() => localStorage.getItem('flo_theme') === 'dark');

  useEffect(() => {
    localStorage.setItem('flo_theme', dark ? 'dark' : 'light');
    const root = document.documentElement;
    if (dark) {
      root.style.setProperty('--bg',     '#111110');
      root.style.setProperty('--bg2',    '#1a1a18');
      root.style.setProperty('--bg3',    '#222220');
      root.style.setProperty('--border', 'rgba(255,255,255,0.07)');
      root.style.setProperty('--border2','rgba(255,255,255,0.13)');
      root.style.setProperty('--text',   '#f0efe9');
      root.style.setProperty('--text2',  '#9b9b96');
      root.style.setProperty('--text3',  '#6b6b66');
    } else {
      root.style.setProperty('--bg',     '#f5f5f3');
      root.style.setProperty('--bg2',    '#ffffff');
      root.style.setProperty('--bg3',    '#f0efe9');
      root.style.setProperty('--border', 'rgba(0,0,0,0.08)');
      root.style.setProperty('--border2','rgba(0,0,0,0.14)');
      root.style.setProperty('--text',   '#1a1a18');
      root.style.setProperty('--text2',  '#6b6b66');
      root.style.setProperty('--text3',  '#9b9b96');
    }
  }, [dark]);

  const toggle = () => setDark(d => !d);

  return (
    <ThemeContext.Provider value={{ dark, toggle }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  return useContext(ThemeContext);
}
